export const CautionVector = () => (
	<svg
		aria-hidden="true"
		focusable="false"
		role="presentation"
		width="108"
		height="100"
		viewBox="0 0 108 100"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.654541 99.1828L0.71345 99.3006H107.293L107.359 99.1828L54.0065 0.582031L0.654541 99.1828Z"
			fill="#DDDEE1"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M51.7909 71.9011V35.8945H56.5887V71.9011H51.7909Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M53.3074 77.8498C53.6565 77.7872 53.9895 77.7686 54.2749 77.7686C54.5768 77.7686 54.876 77.7895 55.1764 77.8357L55.1874 77.8374L55.1985 77.8392C57.1012 78.1501 58.685 79.4742 59.0687 81.5901C59.1362 81.9485 59.1545 82.2927 59.1545 82.5762C59.1545 82.7961 59.1435 83.0437 59.1087 83.3059V83.3461L59.071 83.5564C58.6923 85.6662 57.1123 87.007 55.1985 87.3197L55.1874 87.3215L55.1764 87.3232C54.876 87.3694 54.5768 87.3904 54.2749 87.3904C53.9874 87.3904 53.6515 87.3715 53.2997 87.3077C51.4218 86.9824 49.8458 85.6702 49.4617 83.564C49.3951 83.211 49.3756 82.881 49.3756 82.5827C49.3756 82.2876 49.3946 81.9472 49.4631 81.5875C49.8516 79.5134 51.3948 78.1714 53.3074 77.8498ZM54.1735 82.5702C54.1734 82.5742 54.1734 82.5784 54.1734 82.5827C54.1734 82.5848 54.1734 82.5868 54.1734 82.5888C54.1756 82.589 54.178 82.5892 54.1806 82.5894C54.203 82.5911 54.2343 82.5925 54.2749 82.5925C54.3056 82.5925 54.3327 82.5917 54.3566 82.5904C54.3567 82.5858 54.3567 82.5811 54.3567 82.5762C54.3567 82.5736 54.3567 82.5711 54.3567 82.5686C54.3327 82.5672 54.3056 82.5664 54.2749 82.5664C54.2343 82.5664 54.203 82.5678 54.1806 82.5696C54.178 82.5698 54.1756 82.57 54.1735 82.5702Z"
			fill="white"
		/>
	</svg>
);
